"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrossPromoModule = void 0;
var tslib_1 = require("tslib");
var interfaces_1 = require("@dp-instant/interfaces");
var inversify_1 = require("inversify");
var core_1 = require("@dp-instant/core");
var utils_1 = require("@dp-instant/utils");
var i18n_1 = require("@dp-instant/i18n");
var CONFIGS = [
    {
        id: "1",
        social: {
            fb: { id: "611639816037657" },
            ok: { id: "512000876793" },
            ya: { id: "181508" },
            vk: { id: "8212151" }
        },
        icon: "logo-hidden-object.jpg"
    },
    {
        id: "2",
        social: {
            fb: { id: "258766835191242" },
            ok: { id: "512000645067" },
            vk: { id: "8212147" },
            ya: { id: "184478" }
        },
        icon: "logo-blocks.jpg"
    },
    {
        id: "3",
        social: {
            fb: { id: "778673846242493" },
            ok: { id: "512000897558" },
            vk: { id: "8020393" },
            ya: { id: "161418" }
        },
        icon: "logo-chain-cube.jpg"
    },
    {
        id: "4",
        social: {
            fb: { id: "159047249520140" },
            ok: { id: "512000948950" },
            vk: { id: "8212140" },
            ya: { id: "191972" }
        },
        icon: "logo-state-io.jpg"
    },
    {
        id: "5",
        social: {
            fb: { id: "688260459121199" },
            ok: { id: "512001178168" },
            vk: { id: "8212155" },
            ya: { id: "195514" }
        },
        icon: "word-battle.jpg"
    },
    {
        id: "6",
        social: { fb: { id: "427004178938893" }, ya: { id: "201598" } },
        icon: "logo-homo-evolution.jpg"
    },
    { id: "7", social: { fb: { id: "3098083237124205" } }, icon: "onnet.jpg" }
];
exports.CrossPromoModule = new inversify_1.ContainerModule(function (bind, unbind, isBound) {
    i18n_1.Localize.addTemplates({
        game_title_1: {
            default: "Hidden Objects",
            localizations: { ru_RU: "Поиск предметов" }
        },
        game_title_2: {
            default: "Nine Blocks",
            localizations: { ru_RU: "Блоки" }
        },
        game_title_3: {
            default: "Chain Cube",
            localizations: { ru_RU: "Кубики 2048" }
        },
        game_title_4: {
            default: "State.io",
            localizations: { ru_RU: "Битва за территории" }
        },
        game_title_5: { default: "Word Battle", localizations: { ru_RU: "Вокруг слова" } },
        game_subtitle_1: {
            default: "Brain Teaser",
            localizations: { ru_RU: "Hidden Objects" }
        },
        game_subtitle_2: {
            default: "Game",
            localizations: { ru_RU: "головоломка блок-пазл" }
        },
        game_subtitle_3: {
            default: "2048",
            localizations: { ru_RU: "2048" }
        },
        game_subtitle_4: {
            default: "Conquer the World",
            localizations: { ru_RU: "State.io" }
        },
        game_subtitle_5: {
            default: "Challenge your friends online",
            localizations: { ru_RU: "Word Battle" }
        },
        game_title_6: { default: "Homo Evolution", localizations: { ru_RU: "Homo Evolution" } },
        game_subtitle_6: {
            default: "Create your own little world",
            localizations: { ru_RU: "Создай свой маленький мир" }
        },
        game_title_7: { default: "Onnet Match Pairs" },
        game_subtitle_7: { default: "Connect the pairs with up to 3 lines." }
    });
    var configs;
    var initConfigs = function () {
        return CONFIGS.filter(function (cfg) { return !!cfg.social[__SOCIAL__]; }).map(function (conf) {
            var _a;
            return ({
                appId: ((_a = conf.social[__SOCIAL__]) === null || _a === void 0 ? void 0 : _a.id) || "",
                title: i18n_1.Localize.get("game_title_".concat(conf.id)),
                subtitle: i18n_1.Localize.get("game_subtitle_".concat(conf.id)),
                icon: conf.icon
            });
        });
    };
    bind(interfaces_1.TypesPromo.config).toDynamicValue(function () {
        if (!configs) {
            configs = initConfigs();
        }
        return { games: configs };
    });
    bind(interfaces_1.TypesPromo.random).toDynamicValue(function () {
        if (!configs) {
            configs = initConfigs();
        }
        var appDefines = core_1.di.get(interfaces_1.TypesCore.gameConfig);
        return utils_1.Random.from(configs.filter(function (g) { return g.appId !== appDefines.sid; }));
    });
    bind(interfaces_1.TypesPromo.randomComponent).toDynamicValue(function () {
        var e_1, _a;
        if (isBound(interfaces_1.TypesPromo.component)) {
            if (!configs) {
                configs = initConfigs();
            }
            var shuffledGames = configs.sort(utils_1.Random.sign);
            try {
                for (var shuffledGames_1 = tslib_1.__values(shuffledGames), shuffledGames_1_1 = shuffledGames_1.next(); !shuffledGames_1_1.done; shuffledGames_1_1 = shuffledGames_1.next()) {
                    var config = shuffledGames_1_1.value;
                    if (isBound(config.icon)) {
                        var icon = core_1.di.get(interfaces_1.TypesPromo.component);
                        icon.config = config;
                        return icon;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (shuffledGames_1_1 && !shuffledGames_1_1.done && (_a = shuffledGames_1.return)) _a.call(shuffledGames_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    });
});
//# sourceMappingURL=CrossPromoModule.js.map